import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, Typography } from 'investira.react.components';

/**
 * Renderiza o componente SingleInput.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.title - Título exibido pelo componente.
 * @param {string} props.caption - Propriedade `caption` do componente.
 * @param {Object} props.InputProps - Props adicionais repassadas ao input interno.
 * @param {Object} props.restProps - Props adicionais repassadas para `restProps`.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const SingleInput = memo(props => {
    const { title, caption, InputProps, ...restProps } = props;
    const { sx, ...restInputProps } = InputProps;

    return (
        <Box>
            {title && (
                <Typography
                    variant="h5"
                    color="text.primary"
                    sx={{
                        fontWeight: 500,
                        mb: 1
                    }}>
                    {title}
                </Typography>
            )}
            {caption && (
                <Typography variant="caption" color="text.primary">
                    {caption}
                </Typography>
            )}
            <TextField
                fullWidth
                {...restProps}
                InputProps={{
                    sx: {
                        fontSize: '1.8rem',
                        padding: '1.5rem 1rem 1rem 1rem',
                        ...sx
                    },
                    ...restInputProps
                }}
            />
        </Box>
    );
});

SingleInput.propTypes = {
    title: PropTypes.string,
    caption: PropTypes.string,
    InputProps: PropTypes.object
};

SingleInput.defaultProps = {
    title: '',
    caption: '',
    InputProps: {}
};

SingleInput.displayName = 'SingleInput';

export default SingleInput;
